"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimulatePricingDto = void 0;
class SimulatePricingDto {
    /** Optional display ID. If provided, values will be taken from the display */
    date;
    durationSeconds;
    preferredModels;
    config;
    display;
}
exports.SimulatePricingDto = SimulatePricingDto;
